var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-3 alert-success"},_vm._l((_setup.storeSuccess),function(item,i){return _c(_setup.SuccessItem,{key:i,attrs:{"item":item,"index":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }